import React from 'react';

const Icon = ({ size = '50', fill = 'white', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 51 51" fill="none" {...other}>
            <path
                clipRule="evenodd"
                d="M9.078 11.167c0-1.15.933-2.083 2.084-2.083h29.166c1.15 0 2.083.933 2.083 2.083v29.167c0 1.15-.932 2.083-2.083 2.083H11.161a2.083 2.083 0 0 1-2.083-2.083V11.167Z"
                stroke={fill}
                strokeWidth="1.875"
            />

            <path
                d="M32.61 24.285h3.225v9.677h-3.226v-9.677Zm-11.095-6.451h3.003l6.209 16.121H27.7l-1.512-4.267h-6.436l-1.512 4.267h-2.913l6.187-16.121Zm1.512 2.777h-.067l-2.439 6.932h4.922l-2.416-6.932Zm9.637.449 2.016-3.226-.403 2.42h1.613l-2.016 3.225.403-2.42h-1.613Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
